import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import logo from "../assets/jglogo.jpg";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img src={logo} alt='JG Group' className='h-20 w-20'/>
            </div>
            <p className="text-gray-400 text-sm">
              Celebrating 75 years of excellence in education and service to the nation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors" data-testid="footer-about-link">About Us</Link></li>
              <li><Link to="/events" className="text-gray-400 hover:text-orange-400 transition-colors" data-testid="footer-events-link">Events</Link></li>
              <li><Link to="/gallery" className="text-gray-400 hover:text-orange-400 transition-colors" data-testid="footer-gallery-link">Gallery</Link></li>
              <li><Link to="/spotlight" className="text-gray-400 hover:text-orange-400 transition-colors" data-testid="footer-spotlight-link">Spotlight</Link></li>
              <li><Link to="/faqs" className="text-gray-400 hover:text-orange-400 transition-colors" data-testid="footer-faqs-link">FAQs</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Contact Us</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Shri JG College Of Para Medical Courses
                      Dr. Gangadhar Nagar
                      Ghataprabha - 591 306
                      Tq : Gokak, Dist : Belagavi
                      Karnataka</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={16} />
                <span> 08332-286262,286933</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={16} />
                <span>jgchspmcourse@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Follow Us</h3>
            <div className="flex space-x-3">
              <a href="https://www.instagram.com/jgco_official1951/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors" data-testid="footer-instagram">
                <Instagram size={18} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors" data-testid="footer-facebook">
                <Facebook size={18} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors" data-testid="footer-twitter">
                <Twitter size={18} />
              </a>
              <a href="https://www.youtube.com/@greysquadshrijgcoamc3581" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-gray-800 hover:bg-orange-600 flex items-center justify-center transition-colors" data-testid="footer-youtube">
                <Youtube size={18} />
              </a>
            </div>
            <div className="mt-6">
              <Link to="/admin" className="text-xs text-gray-500 hover:text-orange-400 transition-colors" data-testid="footer-admin-link">
                Admin Panel
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-700 text-sm text-gray-400 flex flex-col md:flex-row md:items-center md:justify-between text-center gap-2">
          <p>
            &copy; 2025 JG Group. All rights reserved. | Celebrating 75 Years of Excellence
          </p>

          <p className="text-gray-400">
            Designed by <a href='https://x7ittechnologies.com' target='blank'>
            <span className="ml-1 text-gray-400 hover:text-blue-400 cursor-pointer transition-colors duration-200">
              X7 IT Technologies
            </span></a>
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;